import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import { WorkOrderService, ActualCuttingService } from "../../../services/index";


@Component({
  selector: "cutting-dc-print",
  templateUrl: "./cuttingDcPrint.html",
})
export class cuttingDcPrint implements OnInit {
  @Output() partyUpdateEvent = new EventEmitter();
  tabTitle: string;
  tabID: string;
  mode: string;
  @Input() partydata: any = [];
  partyList: any = [];
  list: any = [];
  agentList: any = [];
  designList: any = [];
  printdata: any = {};
  woGrTot : number = 0;
  woGrTotMtr : number = 0;
  wodata: any = {};
  dataList : any = [];
  woDetails : any;
  alphabet: string[];
  predefCol : number;
  userDefCol : number;
  cuttingRatio : number;
  woCons : number;
  maxColor : number;
  toDay : any;
  value: number;
  @Input() set printdt(val: any[]) {
    this.printdata = val;
    // console.log(this.printdata,"receive From Cutting Dc");
    // this.getDesignList(this.printdata.cutting_dc_no,this.printdata.cutting_dc_date);
  if(this.printdata.page_type == 'cuttingto_store'){
      this.getDesignList(this.printdata.cutting_dc_no,this.printdata.cutting_dc_date,'cuttingdc');
  } else if(this.printdata.page_type == 'cuttingto_fusing'){
    this.getDesignList(this.printdata.fusing_dc_no,this.printdata.fusing_dc_date,'fusingdc');
  } else if(this.printdata.page_type == 'cuttingto_front'){
    this.getDesignList(this.printdata.front_dc_no,this.printdata.front_dc_date,'frontdc');
  } else if(this.printdata.page_type == 'cuttingto_collar'){
    this.getDesignList(this.printdata.collar_dc_no,this.printdata.collar_dc_date,'collardc');
  } else if (this.printdata.page_type == 'cuttingto_sewing'){
    this.getDesignList(this.printdata.sewing_dc_no,this.printdata.sewing_dc_date,'sewingdc'); 
  }

}

  isLoading: boolean = false;
  @ViewChild("partyForm") partyForm;
  orderfromdtControl: FormControl = new FormControl();
  ordertodtControl: FormControl = new FormControl();
  salesfromdtControl: FormControl = new FormControl();
  salestodtControl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();

  constructor(
    public store: Store<fromRootStore.State>,
    private ActualCuttingService: ActualCuttingService,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService,
    public datePipe: DatePipe
  ) {}

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
    }, 100);
  }

  getDesignList(dc_no,dc_date,type) {
    let params = {
        dc_no : dc_no,
        dc_date : dc_date,
        dc_type : type
    };
    let that = this;
    that.ActualCuttingService.getCuttingDcPrint(params).then((res: any) => {
      that.dataList = res.data;
    });
  }

  print(div) {
    var content = document.getElementById(div).innerHTML;
    var mywindow = window.open("", "Print", "height=850,width=1000");
    mywindow.document.write(content);
    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/cuttingStore/cuttingDcPrint.ts